import React from "react";

/**
 * @param {{ title: string, children: React.ReactNode, footer?: React.ReactNode, variant?: 'card' | 'plain' | 'table' }} props
 */
export function AccountSection({ title, children, footer, variant = "card" }) {
  return (
    <section
      className={`my-account-section${
        variant === "table" ? " my-account-section--table" : ""
      }${variant === "plain" ? " my-account-section--plain" : ""}`}
    >
      <h2 className="my-account-section__title">{title}</h2>
      {variant === "card" ? (
        <div className="my-account-section__card">{children}</div>
      ) : (
        children
      )}
      {footer ? <div className="my-account-section__footer">{footer}</div> : null}
    </section>
  );
}

export default AccountSection;
